import script from "./InstituteOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./InstituteOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./InstituteOnboarding.vue?vue&type=style&index=0&id=6ea8f0a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea8f0a3"]])

export default __exports__